function formatDateTime(value) {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return date.toLocaleString()
}

export default function SessionResolutionModal({
  isOpen,
  sessionResolution,
  onReplace,
  onCancel,
}) {
  if (!isOpen) return null

  const prior = sessionResolution?.priorSession || {}
  const suggested = String(sessionResolution?.suggestedAction || '').toLowerCase()

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4">
      <div className="w-full max-w-lg rounded-xl bg-surface p-6 shadow-2xl">
        <h3 className="text-xl font-bold text-on-surface">Resolve Existing Session</h3>
        <p className="mt-2 text-sm text-on-surface-variant">
          We found an existing session for this user. Choose how to close it before continuing login.
        </p>

        <div className="mt-4 rounded-lg bg-surface-container-low p-4 text-sm text-on-surface-variant">
          <p>
            <span className="font-semibold text-on-surface">Previous login:</span> {formatDateTime(prior?.loginAt)}
          </p>
          <p>
            <span className="font-semibold text-on-surface">Last heartbeat:</span> {formatDateTime(prior?.lastHeartbeat)}
          </p>
          <p>
            <span className="font-semibold text-on-surface">Detected state:</span> {String(prior?.inferredStatus || 'unknown').toUpperCase()}
          </p>
        </div>

        {suggested ? (
          <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-primary">
            Suggested: Replace Session
          </p>
        ) : null}

        <div className="mt-6 flex flex-col gap-2">
          <button
            type="button"
            onClick={onReplace}
            className="rounded-md bg-primary px-4 py-2.5 text-sm font-semibold text-on-primary"
          >
            Replace Session
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="rounded-md border border-outline-variant px-4 py-2.5 text-sm font-semibold text-on-surface-variant"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
